module.exports = __webpack_public_path__ + "h5/img/collection-exchange-button.90de266b.png";